// Importaciones de React y de los componentes necesarios.
import React from 'react';
import Informacion from '../component/Informacion'; // Componente que contiene el formulario y datos de contacto.

/**
 * Componente de la página de Contacto.
 * Su única función es renderizar el componente `Informacion`,
 * que a su vez contiene toda la lógica y presentación de la página de contacto.
 */
export const Contacto = () => {
  return (
    <div>
      {/* Renderiza el componente con la información de contacto. */}
      <Informacion />
    </div>
  );
};

// Exporta el componente para ser usado por el enrutador de la aplicación.
export default Contacto;